// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3Sp01","overflowing":"ReadFullNote_overflowing__232vk"};